// TODO: Remove
// @ts-nocheck
/* eslint-disable */

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { common } from '../styles';

interface Props {}

const styles = {} as const;

const AdvocacyShares: FC<Props> = () => {
  const { t } = useTranslation();

  return <h1 style={common.header}>{t('advocacy:shares')}</h1>;
};

export default AdvocacyShares;
